export const SWITCH_SHOW_POPUP = 'switchShowPopup';
export const SET_LOCATION_TYPE = 'setLocationType';
export const CHOOSE_LOCATION = 'chooseLocation';
export const SET_LOCATION = 'setLocation';
export const SET_MAP_FOCUS = 'setMapFocus';
export const EXPAND_POPUP = 'expandPopup';

export const MAP_RESET = 'map reset';
